export const environment = {
  production: false,
  serverUrl: "https://admin.nhaphangorder.vn/api",
  defaultLanguage: "vi-VN",
  supportedLanguages: ["en-US", "vi-VN"],
  firebaseBo: {
    apiKey: 'AIzaSyB6jGyWp3TxYmLxJbXqkxJfYpX2aq8XIe0',
    authDomain: 'nhaphangorder-history.firebaseapp.com',
    projectId: 'nhaphangorder-history',
    storageBucket: 'nhaphangorder-history.firebasestorage.app',
    messagingSenderId: '217201263922',
    appId: '1:217201263922:web:9621790267613ad242432b',
    measurementId: 'G-BXYC0EGKTP',
    databaseURL: 'https://nhaphangorder-history-default-rtdb.asia-southeast1.firebasedatabase.app',
  },
  firebaseIdms: {
    apiKey: 'AIzaSyB6jGyWp3TxYmLxJbXqkxJfYpX2aq8XIe0',
    authDomain: 'nhaphangorder-history.firebaseapp.com',
    projectId: 'nhaphangorder-history',
    storageBucket: 'nhaphangorder-history.firebasestorage.app',
    messagingSenderId: '217201263922',
    appId: '1:217201263922:web:9621790267613ad242432b',
    measurementId: 'G-BXYC0EGKTP',
    databaseURL: 'https://nhaphangorder-history-default-rtdb.asia-southeast1.firebasedatabase.app',
  },
  branchUid: "0MT41D5Z6pFwTLgtQ14c",
  emailPrefix: "nhtb_",
  tenantId: "pandaorder-u9xmr"
};
